<template>
  <Modal class-name="vertical-center-modal" v-model="isDetail" title="影票详情">
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8">
          <div>
            <el-row>
              <el-col :span="8" class="text-right padding-5">
                <label>图片</label>
              </el-col>
              <el-col :span="16" class="padding-5">
                <img style="width: 60px;height: 82px;" :src="info.movie_pic" alt="">
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="8" class="text-right padding-5">
                <label class="color-666">名称</label>
              </el-col>
              <el-col :span="16" class="padding-5">
                <span class="color-222">{{info.movie_title}}</span>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="8" class="text-right padding-5">
                <label class="color-666">时间</label>
              </el-col>
              <el-col :span="16" class="padding-5">
                <span class="color-222">{{info.movie_time}}</span>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="8" class="text-right padding-5">
                <label class="color-666">影院</label>
              </el-col>
              <el-col :span="16" class="padding-5">
                <span class="color-222">{{info.cinema}}</span>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="16">
          <div>
            <el-row>
              <el-col :span="6" class="text-right padding-5">
                <label class="color-666">购票座位
                </label>
              </el-col>
              <el-col :span="18" class="padding-5">
                <span class="color-222 seat-text" v-for="(item,index) of info.seatArr" :key="index">{{item}}</span>
              </el-col>
            </el-row>
          </div>
          <div v-if="info.realSeat!=null && info.realSeat != ''">
            <el-row>
              <el-col :span="6" class="text-right padding-5">
                <label class="color-666">实际座位</label>
              </el-col>
              <el-col :span="18" class="padding-5">
                <span class="color-222 seat-text">{{info.realSeat}}</span>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="6" class="text-right padding-5">
                <label class="color-666">放映时间</label>
              </el-col>
              <el-col :span="18" class="padding-5">
                <span class="color-222">{{info.start_time}}</span>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="6" class="text-right padding-5">
                <label class="color-666">厅/语言</label>
              </el-col>
              <el-col :span="18" class="padding-5">
                <span class="color-222">{{info.hall}}</span>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="6" class="text-right padding-5">
                <label class="col-666">城市</label>
              </el-col>
              <el-col :span="18" class="padding-5">
                <span class="color-222">{{info.city}}</span>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="6" class="text-right padding-5">
                <label class="color-666">地址</label>
              </el-col>
              <el-col :span="18" class="padding-5">
                <span class="color-222">{{info.address}}</span>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
<!--    取票信息-->
    <div class="qrcode">
      <div class="qrcode-text">取票码:<span class="qrcode-span">{{ info.ticketCode }}</span></div>
      <div class="qrcode-img">
        <div class="img-text">取票码截图:</div>
        <el-image class="img" v-for="(item,index) in info.ticketCodeImg" :src="item" alt="" :key="index" :preview-src-list="info.ticketCodeImg"></el-image>
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSure">确定</span>
      </div>
    </div>
  </Modal>
</template>

<script>
  import { Modal } from 'view-design'
  export default {
    name: "Detail",
    components: { Modal },
    props: {},
    created() {},
    data: function () {
      return {
        isDetail: false,
        loading:false,
        // info:{
        //   movie_pic:'https://gw.alicdn.com/i3/O1CN01rZi5il1tJ5VNjCDah_!!6000000005880-0-alipicbeacon.jpg_480x480Q30s150.jpg',
        //   movie_title:'拆弹专家2',
        //   movie_time:'明天 12月6日 18:08',
        //   cinema: '万达影院',
        //   seat:'5排7座',
        //   start_time:'2020-12-27 12:34:00',
        //   hall:'3号激光厅（国语3D）',
        //   city:'厦门',
        //   address:'厦门市集美区银江路137号同集南路万达广场5号门娱乐区4楼'
        // }
        info:{
          movie_pic:'',
          movie_title:'',
          movie_time:'',
          cinema: '',
          seat:'',
          start_time:'',
          hall:'',
          city:'',
          address:'',
          seatArr:[],
          ticketCode:'', // 取票码
          ticketCodeImg:[], // 取票图片
          realSeat:''
        }
      }
    },
    methods: {
      init: function (row) {
        this.isDetail = true
        let movieInfo = row.movieInfo;
        movieInfo = JSON.parse(movieInfo)
        console.log(movieInfo)
        let seat = row.seat;
        this.info = {
          movie_pic: movieInfo[6],
          movie_title: movieInfo[5],
          movie_time: row.createTime,
          cinema: movieInfo[0],
          seat:seat,
          start_time:movieInfo[3],
          hall: movieInfo[1],
          city: movieInfo[8],
          address: movieInfo[7],
          seatArr: JSON.parse(seat)? JSON.parse(seat):seat,
          ticketCode:row.ticketCode,
          ticketCodeImg:row.ticketCodeImg.split(','),
          realSeat:row.realSeat
        }
      },
      handelCancel: function () {
        this.isDetail = false
      },
      handelSure: function () {
        this.handelCancel();
      },
    }
  }
</script>

<style scoped>
  .color-666{
    color: #666666;
  }
  .color-222{
    color: #222222;
  }
  .seat-text{
    padding-right: 3px;
  }
  .seat-text:last-child{
    padding-right:0;
  }
  .font-weight-bold{
    font-weight: bold;
  }
  .text-right{
    text-align: right;
  }
  .padding-5{
    padding: 5px;
  }
  .normal-font {
    color: #FF4F76;;
    font-size: 14px;
  }
  >>> .ivu-modal-body {
    padding: 16px 16px 0px 16px;
  }
  >>> .ivu-modal-content{
    border-radius: 0;
  }
  >>> .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .vertical-center-modal .ivu-modal {
    top: 0;
  }
  >>> .vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 40px 18px;
    text-align: right;
  }
  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .footer-wrapper .btn {
    display: inline-block;
    border-radius: 2px;
    margin-right: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    vertical-align: middle;
    cursor: pointer;
  }
  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }
  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    color: #222222;
  }
  >>> .ivu-modal-footer {
    border-top: none;
  }
  .qrcode{
    margin-top: 10px;
    margin-left: 20px;
  }
  .qrcode-text{
    color: #666666;
  }
  .qrcode-span{
    color: #222222;
    margin-left: 5px;
  }
  .qrcode-img{
    display: flex;
  }
  .img-text{
    color: #666666;
    margin-top: 10px;
  }
  .img{
    margin-top: 10px;
    width: 120px;
    height: 120px;
    margin-right: 5px;
    border: 1px solid #dddddd;
  }
</style>



// WEBPACK FOOTER //
// src/components/official/TicketDetail.vue